"use client"

import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from "lucide-react"
import { useTheme } from "next-themes"
import { Toaster as Sonner, type ToasterProps } from "sonner"

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      // The coloured toasts below (teal success, red error) need rich colours on.
      richColors
      // Clear of the iPhone home indicator: sonner's phone offset is a flat 16px.
      mobileOffset={{ bottom: "calc(env(safe-area-inset-bottom) + 16px)" }}
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
          "--border-radius": "var(--radius)",
          // A save that worked: filled in our teal with white text and icon,
          // in every theme, rather than sonner's pale mint. The tokens carry
          // the dark value and the HYROX skin's (yellow with ink text, which
          // is how that skin keeps text on its accent legible). Errors keep
          // sonner's red.
          "--success-bg": "var(--fvd-teal-solid, #007870)",
          "--success-border": "var(--fvd-teal-solid, #007870)",
          "--success-text": "var(--fvd-teal-solid-on, #FFFFFF)",
        } as React.CSSProperties
      }
      {...props}
    />
  )
}

export { Toaster }
